import axios from 'axios';
import { safeStorage } from '../utils/storage';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// This app is unauthenticated — it only talks to the public endpoints, so the
// interceptor attaches no Bearer token.
api.interceptors.request.use(async (config) => {
  try {
    // Add store ID if available. Read through safeStorage: browsers that block
    // storage (blocked cookies, in-app webviews, sandboxed iframes) throw a
    // SecurityError on localStorage access, which the catch below would turn
    // into a rejected request — breaking form submission for those visitors.
    const selectedStoreId = safeStorage.get('selectedStoreId');
    if (selectedStoreId) {
      config.headers['Store-Id'] = String(selectedStoreId);
    }

    return config;
  } catch (error) {
    console.error('Error in axios interceptor:', error);
    return Promise.reject(error);
  }
}, (error) => {
  return Promise.reject(error);
});

// Add a function to set up the response interceptor with notification capability
export const setupAxiosErrorHandler = (t, showNotification) => {
  // Response interceptor for API errors
  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Only show notification if the function was provided
      if (showNotification) {
        // Get error details
        // const status = error.response?.status;
        let message = error.response?.data?.errors || error.response?.data?.error;
        let title = t('common.backendError.single');
        
        if (Array.isArray(message)) {
          message = '<ul class="list-disc list-inside">' + message.map(msg => `<li>${msg}</li>`).join('') + '</ul>';
          title = t('common.backendError.multiple');
        }
        
        // Set appropriate title based on status code
        // if (status === 401) {
        //   title = 'Authentication Error';
        // } else if (status === 403) {
        //   title = 'Permission Denied';
        // } else if (status === 404) {
        //   title = 'Not Found';
        // } else if (status >= 500) {
        //   title = 'Server Error';
        // }
        
        // Show notification
        showNotification(title, message, 'error');
      }
      
      // Return the error to be handled by the calling code if needed
      return Promise.reject(error);
    }
  );
};

export default api; 